import { Routes, Route } from 'react-router-dom';
import { Layout } from '../../components/AdminDashboard/Layout';
import { Dashboard } from '../../components/AdminDashboard/Dashboard';
import { Leaderboard } from '../../components/AdminDashboard/Leaderboard';
import { ManageHackathon } from '../../components/AdminDashboard/ManageHackathon';
import { HackathonList } from '../../components/AdminDashboard/HackathonList';
import { ManagePanels } from '../../components/AdminDashboard/ManagePanels';
import { MentorAssignment } from '../../components/AdminDashboard/MentorAssignment';
import { AddMember } from '../../components/AdminDashboard/AddMember';

export default function AdminDashboardPage() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="manage-hackathon" element={<HackathonList />} />
        <Route path="manage-hackathon/create" element={<ManageHackathon />} />
        <Route path="manage-hackathon/:id" element={<ManageHackathon />} />
        <Route path="manage-panels" element={<ManagePanels />} />
        <Route path="mentor-assignment" element={<MentorAssignment />} />
        <Route path="add-member" element={<AddMember />} />
      </Route>
    </Routes>
  );
}